/* eslint-disable max-len */
import React from 'react';

const Collage = props => (
  <svg width={19} height={19} {...props}>
    <path
      fill="currentColor"
      d="M3 2h8a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v7h8V3H3zm5 9h8a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 1v3h8v-3H8zm-5-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 1v3h2v-3H3zM14 2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v2h2V3h-2zm0 4h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm0 1v2h2V8h-2z"
    />
  </svg>
);

export default Collage;
